export default __webpack_public_path__ + "static/media/O_2.8dab2e7a.png";